import PlayGroundTryItOutChatbot from "@/components/playground/PlaygroundTryItOutChatBot";

import { useEffect, useState } from "react";
import { MendableFloatingButton, MendableSearch, MendableSearchBar } from "@mendable/search";
// import PulsingAnimation from "@/components/ui/Animations/PulsingAnimation";


const company = 'gpt_4_paper'
const anon_key = '82913e06-975e-40a0-abbf-f709e644fbcb'

export default function gpt_4_paper({ history }: { history: any }) {
    const DefaultLightStyle: any = {
        primaryColor: "#f5f5f5",
        accentColor: "#1FD085",
        textColor: "#1a1a1a",
        inputBackgroundColor: "#f3f3f3",
        buttonTextColor: "#ffffff"
    }

    const DefaultLightMessageStyle: any = {
        darkMode: false,
        aiTextColor: "#1a1a1a",
        userTextColor: "#1a1a1a",
        accentColor: "#1FD085",
    }


    const DefaultLightFloatingButtonStyle: any = {
        color: "#ffffff",
        backgroundColor: "#1FD085",
    }
    const DefaultLightSourcesStyle = {
        accentColor: "#1FD085",
        darkMode: false,
    }


    // const [color, setColor] = useState('#00ff00');
    // const colors = ['#00ff00', '#ff00ff', '#00ffff', '#ffff00'];

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         const colorIndex = Math.floor(Math.random() * colors.length);
    //         setColor(colors[colorIndex]);
    //     }, 2000);

    //     return () => clearInterval(interval);
    // }, [colors]);

    return <div className="w-full bg-white h-screen flex flex-col items-center justify-center">
        {/* <PulsingAnimation></PulsingAnimation> */}

        <h3 className="text-3xl text-black ">Ask the GPT-4 paper anything</h3>
        <div className="w-full max-w-xl mt-10 mb-4">
            <MendableSearchBar style={{ darkMode: false, accentColor: "#2361DD" }} anon_key={anon_key} />
        </div>
        <p className="text-sm text-[#626161] mb-10">Includes data from the <a href='https://cdn.openai.com/papers/gpt-4.pdf'>GPT-4 paper</a> and <a href='https://cdn.openai.com/papers/gpt-4-system-card.pdf'>gpt-4 system card</a></p>
        <h3 className="text-xl text-black "> Press <span className="font-bold text-black uppercase tracking-wider">CMD + K</span> to get started.</h3>
        {/* create a button thats links to the mendable homepage, give it the text Check out mendable,and  uses bg-primary */}
        <button className="fixed rounded-md bg-primary my-10  bottom-10 ">
            <a href="https://mendable.ai" className="text-white hover:text-white px-2 py-8 rounded-md mt-10">Check out Mendable</a>
        </button>
    </div>

}